<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="container-fluid" [ngClass]="usuario.retorno.aparencia">
  <div style="margin-top: 20px;">
    <ul class="breadcrumb">
      <li><strong>Onde estou:</strong></li>
      <li class="active">
        <span id="lblSubMenu">Relatório de Abastecimentos Editáveis</span>
      </li>
    </ul>
    <div class="clearfix">


      <div class="pull-right subfrotas-botoes">
        <button class="btn btn-default btn-primary btn-primary-negativo" (click)="isCollapsed = ! isCollapsed"
                [attr.aria-expanded]="!isCollapsed" aria-controls="collapseFilter"><i class="fa fa-filter"></i>
          Filtrar resultados
        </button>
      </div>
    </div>
    <aside #collapse="ngbCollapse" [ngbCollapse]="!isCollapsed">
      <div class="panel panel-default form-filtrar form-default">
        <form class="panel-body">
          <h1>Filtrar Abastecimentos</h1>
          <div class="row">

          </div>
          <div class="row" [formGroup]="filtroForm">

            <div class="col-md-2 form-group" *ngIf="usuario.retorno.tipo === 2">
              <label class='center-block'>
               Código do Posto
              </label>
              <input type="text" class="form-control"  maxlength="6" formControlName="codPosto"
                     placeholder="Ex. ABC1D23">
              <small *ngIf="filtroForm.get('codPosto')?.hasError('maxlength') && filtroForm.get('codPosto')?.touched">Máx.
                de 6 caracteres</small>
            </div>

            <div class="col-md-2 form-group" *ngIf="usuario.retorno.tipo === 3">
              <label class='center-block'>
                Código da Frota
              </label>
              <input type="text" class="form-control"  maxlength="6" formControlName="codFrota"
                     placeholder="Ex. ABC1D23">
              <small *ngIf="filtroForm.get('codFrota')?.hasError('maxlength') && filtroForm.get('codFrota')?.touched">Máx.
                de 6 caracteres</small>
            </div>


            <div class="col-md-3 form-group">
              <label class='center-block'>
                Placa
              </label>
              <input type="text" class="form-control" id="dscPlaca" maxlength="7" formControlName="dscPlaca"
                     placeholder="Ex. ABC1D23">
              <small *ngIf="filtroForm.get('dscPlaca')?.hasError('maxlength') && filtroForm.get('dscPlaca')?.touched">Máx.
                de 7 caracteres</small>
            </div>


            <div class="col-md-3 form-group">
              <label class='center-block'>
                Combustível
              </label>
              <select class="form-control" formControlName="indCombustivel" name="indCombustivel" id="indCombustivel">
                <option value="">Todos combustíveis</option>
                <option *ngFor="let comb of listaCombustiveis"
                        [value]="comb.descricaoCombustivel">{{comb.combustivel | titlecase}}</option>
              </select>

            </div>

            <div class="col-md-2 form-group">
              <label class='center-block'>
                Data Inicio
              </label>
              <input type="date" class="form-control" formControlName="datIniAbastecimento" id="datIniAbastecimento"
                     name="datIniAbastecimento" value="">
              <small
                *ngIf="filtroForm.get('datIniAbastecimento')?.hasError('invalidDateRange') && filtroForm.get('datIniAbastecimento')?.touched">Não
                permitido data futura</small>


            </div>

            <div class="col-md-2 form-group">
              <label class='center-block'>
                Data Fim
              </label>
              <input type="date" class="form-control" formControlName="datFimAbastecimento" id="datFimAbastecimento"
                     name="datFimAbastecimento" value="">
              <small
                *ngIf="filtroForm.get('datFimAbastecimento')?.hasError('invalidDateRange') && filtroForm.get('datFimAbastecimento')?.touched">Não
                permitido data futura</small>
              <small
                *ngIf="filtroForm.get('datFimAbastecimento')?.hasError('invalidDataFim') && filtroForm.get('datFimAbastecimento')?.touched">Não
                permitido data fim anterior a inicio ou necessário incluir data inicio</small>

            </div>
          </div>


          <div class="clearfix btn-filtrar-abastecimentos">
            <div class="pull-right subfrotas-botoes">
              <button type="submit"
                      [disabled]="!filtroForm.valid || !filtroForm.touched"
                      (click)="filtrarDados()"
                      class="btn btn-default btn-primary btn-primary-negativo">
                <i class="fa fa-check"></i>
                 Filtrar
              </button>
          </div>
        </div>
        </form>
      </div>
    </aside>


    <div class="lista-container">


      <mat-table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter" [hiddenColumns]="[0]">


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>

        <ng-container matColumnDef="flgEditavel" stickyEnd>
          <mat-header-cell *matHeaderCellDef style="border-bottom-width:0px; height: 30px;">
          Ações</mat-header-cell>>
          <mat-cell *matCellDef="let row">
            <button class="btn btn-secondary"
              *ngIf="row.flgEditavel"
              [disabled]="!row.flgEditavel" mat-menu-item
              routerLink="/subfrota/mostrar-abastecimento-editado"
              [state]="{abst: row, combustiveis: listaCombustiveis}"

            ><i class="fa fa-edit"></i>Editar
            </button>
          </mat-cell>
        </ng-container>

        <!-- Código SubFrota Column -->
        <ng-container matColumnDef="nomFantasiaPosto" *ngIf="usuario.retorno.tipo === 2">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Posto </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.codPosto}} - {{row.nomFantasiaPosto}} </mat-cell>
        </ng-container>

        <!-- Código SubFrota Column -->
        <ng-container matColumnDef="codFrota" *ngIf="usuario.retorno.tipo === 3">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Frota </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.codFrota}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dscPlaca">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Placa </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.dscPlaca}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="datAbastecimento">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Data do Abastecimento </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.datAbastecimento}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="indCombustivel">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Combustível </mat-header-cell>
          <mat-cell *matCellDef="let row">

            {{ mostrarNomeCombustivel(row.indCombustivel)}}



          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="qtdVolume">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Volume </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.qtdVolume}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="vlrUnitario">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Preço Unitário </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.vlrUnitario}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="vlrTotal">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Preço Total </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.vlrTotal}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="numKm">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Km </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.numKm}} </mat-cell>
        </ng-container>






      </mat-table>

      <mat-paginator #paginator class="filter-paginator" [pageSizeOptions]="[10, 20, 50, 100, 500, 1000, 9999]"
                     [pageSize]="10" aria-label="Seleciona a página">
      </mat-paginator>

    </div>
  </div>
</div>
